import Vue from "vue";
import Vuex from "vuex";
import http from "./http";
// import da from "element-ui/src/locale/lang/da";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // language: null,
    language: {
      visitor: [],
      home: [],
      staff: [],
      vreserve: [],
      scode: []
    },
    visitor: null,
    staff: [],
    sname: null,
    reasons: null,
    area: null,
    area2: null,
    department: null,
    sms_code: null,

    // reasons:null,

    code: null,
    msg: null,
    history: [],
    access: [],
    record: [],
    region: {
      regular: [],
      unregular: []
    },
    ticket: [],
    recordInfo: [],
    visitor_type: [],
    leader_lst: [], //审批人列表
    // ====================================================
    // 后台
    //=====================================================
    user: null,
    // staff: [],
    getRegion: null,
    getInvite: null,
    getInvite_total: 0,

    record_reserve: null,
    record_reserve_total: 0,

    getArrive: null,
    getArrive_total: 0,
    system: null,
    getPort: [],
    item_type: null, // 物品类型
    release_reason: null, // 放行原因
    release_record: null, // 放行条记录列表
    release_record_detail: null, // 放行条记录详细信息
    release_leader_lst: null, // 放行条审批人列表
    corp_lst: null, // 企业列表

    image: [], // 上传的人脸照片信息
    id: 0,

    w_data: null,
    truck: null,

    corp_ticket: null,

    photo_url: null,
    timu: [],
    idcard_information: null,
    visitor_list: [],
    car_type: [], // 车辆类型
    car_jtfs: [], // 交通方式
    car_clxz: [], // 车辆性质

    organize_list: [], // 组织列表
    notice: null, // 来访须知
    main_photo: [], // 主图信息
    server: [], // 整合获取拜访事由、获取拜访单位、获取访客类型、获取组织列表

    data_info: [],
    car_user:[], // 车牌登录状态
    car_qr:[], //当前二维码数据
  },
  mutations: {
    // 车牌 —— 登录
    SET_CAR_USER: (state, item) => {
      state.code = item.code;
      state.car_user = item.data;
      state.code_secret_id = item.code_secret_id;
    },

    SET_CAR_USERMOBILE: (state, item) => {
      state.code = item.code;
      state.code_secret_id = item.data.code_secret_id;
    },

    SET_CAR_QR: (state, item) => {
      // console.log(item)
      state.code = item.code;
      state.car_qr = item.data;
    },





    SET_IDCARD_INFORMATION: (state, item) => {
      state.idcard_information = item.data;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_TIMU: (state, item) => {
      state.timu = item;
    },
    SET_DATA: (state, item) => {
      state.code = item.code;
      state.msg = item.msg;
      state.id = item.id;
      // console.log(state.id)
    },

    SET_DATA_SECRETID: (state, item) => {
      state.code = item.code;
      state.msg = item.msg;
      state.secret_id = item.data.secret_id;
      // console.log(state.secret_id)
    },

    SET_INTERVIEW_DATA: (state, item) => {
      state.code = item.code;
      state.msg = item.msg;
      state.id = item.data.id;
    },
    // SET_HISTORY: (state, item) => {
    //     state.history = item;
    // },
    SET_ACCESS: (state, item) => {
      state.access = item;
    },
    SET_REGION: (state, item) => {
      state.region = item;
    },
    SET_RECORD: (state, item) => {
      state.record = item;
    },
    SET_TICKET: (state, item) => {
      state.ticket = item;
    },
    SET_LANGUAGE: (state, item) => {
      state.language = item;
    },
    SET_RECORD_INFO: (state, item) => {
      state.recordInfo = item;
    },
    SET_VISITOR_TYPE: (state, item) => {
      state.visitor_type = item;
    },
    SET_VISITOR_INFO: (state, item) => {
      state.visitor = item.data;
      state.code = item.code;
      state.msg = item.msg;
      console.log(item);
    },
    SET_TRUCK_INFO: (state, item) => {
      state.truck = item.data;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_STAFF_NAME: (state, item) => {
      state.code = item.code;
      state.sname = item.data.name;
    },
    SET_STAFF_INFO: (state, item) => {
      state.staff = item.data;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_SMS_CODE: (state, item) => {
      console.log(item);
      state.sms_code = item.data.sms_code;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_LEADER_LST: (state, item) => {
      state.leader_lst = item.data.leader_lst;
      // console.log(item);
      state.code = item.code;
      state.msg = item.msg;
    },

    SET_W_DATA: (state, item) => {
      state.w_data = item.data;
      // console.log(item);
      state.code = item.code;
      state.msg = item.msg;
    },

    SET_VISITOR_LIST_DATA: (state, item) => {
      state.visitor_list = item.data;
      // console.log(item);
      state.code = item.code;
      state.msg = item.msg;
    },

    // SET_REASONS: (state, item) => {
    //     state.reasons = item;
    // },
    // =====================================================
    // 后台
    // =====================================================
    SET_USER: (state, item) => {
      state.user = item;
    },
    SET_STAFF: (state, item) => {
      // 设置被访人信息
      state.staff = item;
    },
    SET_DEPARTMENT: (state, item) => {
      //设置部门信息
      state.department = item;
    },
    SET_REASONS: (state, item) => {
      //设置来访事由
      state.code = 0;
      state.reasons = item;
    },
    SET_AREA: (state, item) => {
      //设置拜访厂区
      state.code = 0;
      state.area = item;
      // console.log(item)
    },
    SET_AREA2: (state, item) => {
      //设置拜访区域
      state.code = 0;
      state.area2 = item;
      // console.log(item)
    },
    SET_RECORD_RESERVE: (state, item) => {
      state.record_reserve = item.record;
      state.record_reserve_total = item.total;
    },
    SET_GET_REGION: (state, item) => {
      state.getRegion = item;
    },
    SET_GET_INVITE: (state, item) => {
      state.getInvite = item.record;
      state.getInvite_total = item.total;
    },
    SET_GET_ARRIVE: (state, item) => {
      state.getArrive = item.record;
      state.getArrive_total = item.total;
    },
    SET_SYSTEM: (state, item) => {
      state.system = item;
    },
    SET_GET_PORT: (state, item) => {
      state.getPort = item;
    },

    SET_ITEM_TYPE: (state, item) => {
      state.item_type = item;
    },
    SET_RELEASE_REASON: (state, item) => {
      state.release_reason = item;
    },
    SET_RELEASE_RECORD: (state, item) => {
      state.release_record = item;
    },
    SET_RELEASE_RECORD_DETAIL: (state, item) => {
      state.release_record_detail = item.data;
      state.code = item.code;
    },
    SET_RELEASE_LEADER_LST: (state, item) => {
      state.release_leader_lst = item.data.leader_lst;
    },
    SET_CORP_LST: (state, item) => {
      state.corp_lst = item;
    },
    SET_IMAGE: (state, item) => {
      state.msg = item.msg;
      state.code = item.code;
      state.photo_url = item.data.image_path;
      // console.log(1231);
      // console.log(state.photo_url);
    },
    SET_CORP_TICKET: (state, item) => {
      // console.log(item);
      // console.log("----");
      state.code = 0;
      state.corp_ticket = item;
    },
    // 设置车辆类型
    SET_CAR_TYPE: (state, item) => {
      state.car_type = item;
    },
    // 设置交通方式
    SET_CAR_JTFS: (state, item) => {
      state.car_jtfs = item;
    }, // 设置车辆性质
    SET_CAR_CLXZ: (state, item) => {
      state.car_clxz = item;
    },

    SET_ORGANIZE_LIST: (state, item) => {
      state.organize_list = item;
    },
    SET_NOTICE: (state, item) => {
      // 来访须知
      state.notice = item;
    },
    SET_MAIN_PHOTO: (state, item) => {
      state.main_photo = item.data;
      console.log(item.data);
    },
    SET_SERVER: (state, item) => {
      // 来访须知
      state.server = item;
    },

    // 处理后端返回的数据
    SET_DATA_INFO: (state, item) => {
      const key = item.data.key;

      state.msg = item.msg;
      state.code = item.code;
      console.log(item.data[key]);
      state.data_info[key] = item.data[key];
    }
  },
  actions: {
    async getCorpLst({ commit }, content) {
      //获取企业列表

      const { data } = await http.getCorpLst(content);
      // console.log(data);
      commit("SET_CORP_LST", data.data);
    },

    async lang({ commit }, content) {
      //获取语言信息
      // async lang({commit}) {//获取语言信息
      const { data } = await http.lang(content);
      // console.log(data);
      // commit('SET_LANGUAGE', data.data);
      commit("SET_LANGUAGE", data.data);
    },
    // async getVisitorRecord({commit}) {//邀请记录
    //     const {data} = await http.history();
    //     if (data.code === 0) {
    //         commit('SET_RECORD', data.data);
    //     } else {
    //         commit('SET_DATA', data)
    //     }
    // },
    async region({ commit }) {
      const { data } = await http.region();
      if (data.code === 0) {
        commit("SET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async record({ commit }) {
      const { data } = await http.record();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async approval({commit}, content) {
    //     const {data} = await http.approval(content.id, content.status, content.cause);
    //     commit('SET_DATA', data);

    // },
    // async num({commit}, content) {
    //     const {data} = await http.num(content.id, content.num);
    //     commit('SET_DATA', data);
    // },
    async invite({ commit }, content) {
      // 被访人邀请客户
      const { data } = await http.invite(content);
      commit("SET_DATA", data);
    },
    async interview({ commit }, content) {
      // HR邀请面试者
      const { data } = await http.interview(content);
      commit("SET_INTERVIEW_DATA", data);
    },
    async vpersonal({ commit }, content) {
      //提交访客个人信息
      const { data } = await http.vpersonal(content);
      commit("SET_DATA", data);
      // console.log({data});
      // console.log(33);
      // commit('SET_DATA', data);
    },

    async getVisitorInfo({ commit }) {
      //获取访客个人信息
      const { data } = await http.getVisitorInfo();
      commit("SET_VISITOR_INFO", data);
    },
    async getStaffName({ commit }, content) {
      //获取被访人姓名
      const { data } = await http.getStaffName(content);
      commit("SET_STAFF_NAME", data);
      // console.log(data.data);
    },
    async staffRefuse({ commit }, content) {
      //被访人员拒绝预约来访
      const { data } = await http.staffRefuse(content);
      commit("SET_DATA", data);
    },
    async staffAgree({ commit }, content) {
      //被访人员同意预约来访
      const { data } = await http.staffAgree(content);
      commit("SET_DATA", data);
    },
    async leaderRefuse({ commit }, content) {
      //领导拒绝预约来访
      const { data } = await http.leaderRefuse(content);
      commit("SET_DATA", data);
    },
    async leaderAgree({ commit }, content) {
      //领导同意预约来访
      const { data } = await http.leaderAgree(content);
      commit("SET_DATA", data);
    },
    async getStaffRecord({ commit }, content) {
      //获取员工的预约、邀请记录
      const { data } = await http.getStaffRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorRecord({ commit }, content) {
      //获取访客预约记录
      const { data } = await http.getVisitorRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorRecordCar({ commit }, content) {
      //获取访客预约记录
      const { data } = await http.getVisitorRecordCar(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getSRecordCar({ commit }, content) {
      //
      const { data } = await http.getSRecordCar(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // async getReasons({commit}, content){//获取来访事由
    //     const {data} = await http.getReasons(content);
    //     commit('SET_REASONS', data);
    //     console.log(data);
    //     console.log(123);
    // },
    async vreserve({ commit }, content) {
      //访客发起预约
      const { data } = await http.vreserve(content);
      commit("SET_DATA", data);
    },
    async vreserveCar({ commit }, content) {
      //访客发起预约
      const { data } = await http.vreserveCar(content);
      commit("SET_DATA", data);
    },
    async vreserve2({ commit }, content) {
      //访客通过员工发起的链接填写预约信息
      const { data } = await http.vreserve2(content);
      commit("SET_DATA", data);
    },

    async getStaffInfo({ commit }, content) {
      //获取被访人个人信息
      const { data } = await http.getStaffInfo(content);
      commit("SET_STAFF_INFO", data);
      // console.log(data);
    },
    async spersonal({ commit }, content) {
      //被访人员绑定身份
      const { data } = await http.spersonal(content);
      commit("SET_DATA", data);
    },
    async saveSpersonal({ commit }, content) {
      //
      const { data } = await http.saveSpersonal(content);
      commit("SET_DATA", data);
    },
    async disSpersonal({ commit }, content) {
      //解除绑定
      const { data } = await http.disSpersonal(content);
      commit("SET_DATA", data);
    },
    async getCode({ commit }, content) {
      //获取验证码
      const { data } = await http.getCode(content);
      commit("SET_SMS_CODE", data);
    },
    async getSRecord({ commit }, content) {
      //被访人员获取模板消息记录
      const { data } = await http.getSRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getLRecord({ commit }, content) {
      //部门领导获取模板消息记录
      const { data } = await http.getLRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVRecord({ commit }, content) {
      //访客获取模板消息记录
      const { data } = await http.getVRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getCRecord({ commit }, content) {
      //抄送人获取模板消息记录
      const { data } = await http.getCRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getTicket({ commit }, content) {
      const { data } = await http.getTicket(content);
      if (data.code === 0) {
        commit("SET_TICKET", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchLeaderLst({ commit }, content) {
      //获取审批人列表
      const { data } = await http.searchLeaderLst(content);
      if (data.code === 0) {
        commit("SET_LEADER_LST", data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },

    // async access({commit}, content) {
    //     const {data} = await http.access();
    //     if (data.code === 0) {
    //         commit('SET_ACCESS', data.data);
    //     } else {
    //         commit('SET_DATA', data)
    //     }
    // },
    // async getRecord({commit}, content) {
    //     const {data} = await http.getRecord(content);
    //     if (data.code === 0) {
    //         commit('SET_RECORD_INFO', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // ======================================================
    // 后台
    // ======================================================
    async signIn({ commit }, content) {
      //登陆后台
      const { data } = await http.signIn(content);
      // console.log(data.data);
      if (data.code === 0) {
        commit("SET_USER", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async staff({ commit }) {
      //获取员工数据
      const { data } = await http.staff();
      if (data.code === 0) {
        commit("SET_STAFF", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createStaff({ commit }, content) {
      //单个添加员工信息
      const { data } = await http.createStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteStaff({ commit }, content) {
      //单个删除员工信息
      const { data } = await http.deleteStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateStaff({ commit }, content) {
      //单个修改员工信息
      const { data } = await http.updateStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchStaff({ commit }, content) {
      //查找指定员工数据
      const { data } = await http.searchStaff(content);
      if (data.code === 0) {
        commit("SET_STAFF", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getDepartment({ commit }, content) {
      //获取部门数据
      const { data } = await http.getDepartment(content);
      if (data.code === 0) {
        commit("SET_DEPARTMENT", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createDepartment({ commit }, content) {
      //单个添加部门信息
      const { data } = await http.createDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteDepartment({ commit }, content) {
      //单个删除部门信息
      const { data } = await http.deleteDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateDepartment({ commit }, content) {
      //单个修改部门信息
      const { data } = await http.updateDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReasons({ commit }, content) {
      //获取来访事由
      const { data } = await http.getReasons(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_REASONS", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getArea({ commit }) {
      //获取拜访厂区
      const { data } = await http.getArea();
      console.log(data);
      if (data.code === 0) {
        commit("SET_AREA", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getArea2({ commit }, content) {
      //获取拜访区域
      const { data } = await http.getArea2(content);
      console.log(data);
      if (data.code === 0) {
        commit("SET_AREA2", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorType({ commit }) {
      //获取来访类型
      const { data } = await http.getVisitorType();
      console.log(data);
      if (data.code === 0) {
        commit("SET_VISITOR_TYPE", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createReasons({ commit }, content) {
      //单个添加来访事由
      const { data } = await http.createReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteReasons({ commit }, content) {
      //单个删除来访事由
      const { data } = await http.deleteReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateReasons({ commit }, content) {
      //单个修改来访事由
      const { data } = await http.updateReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchReserve({ commit }, content) {
      const { data } = await http.searchReserve(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getRegion({ commit }) {
      //获取门禁配置
      const { data } = await http.getRegion();
      if (data.code === 0) {
        commit("SET_GET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async getInvite({commit}, content) {
    //     const {data} = await http.getInvite(content);
    //     if (data.code === 0) {
    //         commit('SET_GET_INVITE', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    async getArrive({ commit }, content) {
      //获取访客到访记录
      const { data } = await http.getArrive(content);
      if (data.code === 0) {
        commit("SET_GET_ARRIVE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async staffData({commit}) {
    //     const {data} = await http.staffData();
    //     commit('SET_DATA', data);
    // },
    // async menuData({commit}) {
    //     const {data} = await http.menuData();
    //     commit('SET_DATA', data);
    // },
    // async changePassword({commit}, content) {
    //     const {data} = await http.changePassword(content);
    //     commit('SET_DATA', data);
    // },

    async getSystem({ commit }) {
      //获取邀请记录
      const { data } = await http.getSystem();
      commit("SET_SYSTEM", data.data);
    },
    async changeSystem({ commit }, content) {
      //修改配置信息
      const { data } = await http.changeSystem(content);
      commit("SET_DATA", data);
    },
    async deleteRegion({ commit }, content) {
      const { data } = await http.deleteRegion(content);
      commit("SET_DATA", data);
    },
    async getPort({ commit }) {
      const { data } = await http.getPort();
      if (data.code === 0) {
        commit("SET_GET_PORT", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async createRegion({commit}, content) {
    //     const {data} = await http.createRegion(content);
    //     commit('SET_DATA', data);
    // },
    // async updateRegion({commit}, content) {
    //     const {data} = await http.updateRegion(content);
    //     commit('SET_DATA', data);
    // },
    async searchInvite({ commit }, content) {
      const { data } = await http.searchInvite(content);
      if (data.code === 0) {
        commit("SET_GET_INVITE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // *************
    // 放行条
    async getItemType({ commit }, content) {
      //获取物品类型
      const { data } = await http.getItemType(content);
      commit("SET_ITEM_TYPE", data.data);
    },
    async getReleaseReason({ commit }) {
      //获取放行原因
      const { data } = await http.getReleaseReason();
      commit("SET_RELEASE_REASON", data.data);
    },
    async createRelease({ commit }, content) {
      //获取发起请假申请
      const { data } = await http.createRelease(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReleaseRecord({ commit }, content) {
      //获取放行条记录列表
      const { data } = await http.getReleaseRecord(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordDetail({ commit }, content) {
      //获取放行条记录列表
      console.log(commit);
      const { data } = await http.getReleaseRecordDetail(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async getReleaseRecordLeader({ commit }, content) {
      //获取放行条记录列表
      console.log(commit);
      const { data } = await http.getReleaseRecordLeader(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async leaderAgreeRelease({ commit }, content) {
      //二级审批同意放行条申请
      console.log(commit);
      const { data } = await http.leaderAgreeRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async leaderRefuseRelease({ commit }, content) {
      //二级审批同意放行条申请
      console.log(commit);
      const { data } = await http.leaderRefuseRelease(content);
      // commit('SET_RELEASE_RECORD_DETAIL', data.data);
      commit("SET_DATA", data);
    },
    async searchReleaseLeaderLst({ commit }, content) {
      //获取放行条审批人列表
      const { data } = await http.searchReleaseLeaderLst(content);
      if (data.code === 0) {
        commit("SET_RELEASE_LEADER_LST", data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getReleaseRecordToday({ commit }, content) {
      //获取放行条审批人列表
      const { data } = await http.getReleaseRecordToday(content);
      if (data.code === 0) {
        commit("SET_RELEASE_RECORD", data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReleaseRecordReturn({ commit }, content) {
      //
      const { data } = await http.getReleaseRecordReturn(content);
      if (data.code === 0) {
        commit("SET_RELEASE_RECORD", data.data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },

    async uploadImages(
      {
        // 把微信公众号的临时照片存储到本地，并反馈照片是人脸是人脸照片是否符合初期的入库标准
        commit
      },
      content
    ) {
      const { data } = await http.uploadImages(content);
      commit("SET_IMAGE", data);
    },

    async getmytype({ commit }, content) {
      //
      const { data } = await http.getmytype(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getVisitorFollow({ commit }, content) {
      //
      const { data } = await http.getVisitorFollow(content);
      commit("SET_W_DATA", data);
    },

    async getVisitorCarFollow({ commit }, content) {
      //
      const { data } = await http.getVisitorCarFollow(content);
      commit("SET_W_DATA", data);
    },

    async addVisitorFollow({ commit }, content) {
      //
      const { data } = await http.addVisitorFollow(content);
      commit("SET_W_DATA", data);
    },

    async addVisitorCarFollow({ commit }, content) {
      //
      const { data } = await http.addVisitorCarFollow(content);
      commit("SET_W_DATA", data);
    },

    async deleteVisitorFollow({ commit }, content) {
      //
      const { data } = await http.deleteVisitorFollow(content);
      commit("SET_DATA", data);
    },

    async getVisitorStaffFollow({ commit }, content) {
      //
      const { data } = await http.getVisitorStaffFollow(content);
      commit("SET_W_DATA", data);
    },

    async addVisitorStaffFollow({ commit }, content) {
      //
      const { data } = await http.addVisitorStaffFollow(content);
      commit("SET_W_DATA", data);
    },

    async deleteVisitorStaffFollow({ commit }, content) {
      //
      const { data } = await http.deleteVisitorStaffFollow(content);
      commit("SET_DATA", data);
    },
    async getStaffLst({ commit }, content) {
      //
      const { data } = await http.getStaffLst(content);
      commit("SET_W_DATA", data);
      // console.log(data.data);
    },

    async getTruckFollow({ commit }, content) {
      //
      const { data } = await http.getTruckFollow(content);
      commit("SET_W_DATA", data);
    },

    async addTruckFollow({ commit }, content) {
      //
      const { data } = await http.addTruckFollow(content);
      commit("SET_W_DATA", data);
    },

    async deleteTruckFollow({ commit }, content) {
      //
      const { data } = await http.deleteTruckFollow(content);
      commit("SET_DATA", data);
    },

    async getTruckStaffFollow({ commit }, content) {
      //
      const { data } = await http.getTruckStaffFollow(content);
      commit("SET_W_DATA", data);
    },

    async addTruckStaffFollow({ commit }, content) {
      //
      const { data } = await http.addTruckStaffFollow(content);
      commit("SET_W_DATA", data);
    },

    async deleteTruckStaffFollow({ commit }, content) {
      //
      const { data } = await http.deleteTruckStaffFollow(content);
      commit("SET_DATA", data);
    },

    async getTruckInfo({ commit }) {
      //
      const { data } = await http.getTruckInfo();
      commit("SET_TRUCK_INFO", data);
    },
    async tpersonal({ commit }, content) {
      //
      const { data } = await http.tpersonal(content);
      commit("SET_DATA", data);
    },
    async treserve({ commit }, content) {
      //
      const { data } = await http.treserve(content);
      commit("SET_DATA", data);
    },

    async getTSRecord({ commit }, content) {
      //被访人员获取模板消息记录
      const { data } = await http.getTSRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getTruckRecord({ commit }, content) {
      //-当天
      const { data } = await http.getTruckRecord(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getTruckRecordToday({ commit }, content) {
      //-当天
      const { data } = await http.getTruckRecordToday(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getTruckRecordDetailToday({ commit }, content) {
      //-当天
      console.log(commit);
      const { data } = await http.getTruckRecordDetailToday(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async securityAgreeReturn({ commit }, content) {
      //保安确认物品返回
      const { data } = await http.securityAgreeReturn(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityRefuseRelease({ commit }, content) {
      //保安拒绝放行
      const { data } = await http.securityRefuseRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityAgreeRelease({ commit }, content) {
      //保安确认放行
      const { data } = await http.securityAgreeRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async securityRefuseTruck({ commit }, content) {
      //
      const { data } = await http.securityRefuseTruck(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityAgreeTruck({ commit }, content) {
      //
      const { data } = await http.securityAgreeTruck(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async staffAgreeReturn({ commit }, content) {
      //
      const { data } = await http.staffAgreeReturn(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async getCorpTicket({ commit }, content) {
      const { data } = await http.getCorpTicket(content);
      // console.log("+++++++");
      if (data.code === 0) {
        commit("SET_CORP_TICKET", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async truckStaffRefuse({ commit }, content) {
      //
      const { data } = await http.truckStaffRefuse(content);
      commit("SET_DATA", data);
    },
    async truckStaffAgree({ commit }, content) {
      //
      const { data } = await http.truckStaffAgree(content);
      commit("SET_DATA", data);
    },
    async truckLeaderRefuse({ commit }, content) {
      //
      const { data } = await http.truckLeaderRefuse(content);
      commit("SET_DATA", data);
    },
    async truckLeaderAgree({ commit }, content) {
      //
      const { data } = await http.truckLeaderAgree(content);
      commit("SET_DATA", data);
    },

    async getScores({ commit }, content) {
      //获取考试分数
      const { data } = await http.getScores(content);
      if (data.code === 0) {
        commit("SET_SCORES", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getKaoShi({ commit }, content) {
      //获取考试题目
      const { data } = await http.getKaoShi(content);
      if (data.code === 0) {
        commit("SET_TIMU", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async submitdati({ commit }, content) {
      //
      const { data } = await http.submitdati(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getIdCardInfomation({ commit }, content) {
      //
      const { data } = await http.getIdCardInfomation(content);
      if (data.code === 0) {
        // commit("SET_DATA", data);
        commit("SET_IDCARD_INFORMATION", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorList({ commit }, content) {
      //
      const { data } = await http.getVisitorList(content);
      commit("SET_VISITOR_LIST_DATA", data);
    },
    async getCarType({ commit }) {
      //获取车辆类型
      const { data } = await http.getCarType();
      commit("SET_CAR_TYPE", data.data);
    },
    async getCarJtfs({ commit }) {
      //获取交通方式
      const { data } = await http.getCarJtfs();
      commit("SET_CAR_JTFS", data.data);
    },
    async getCarClxz({ commit }) {
      //获取车辆性质
      const { data } = await http.getCarClxz();
      commit("SET_CAR_CLXZ", data.data);
    },

    /**
     * 获取组织列表
     * @param {*} param0
     */
    async getOrganizeList({ commit }) {
      const { data } = await http.getOrganizeList();
      console.log(data);
      if (data.code === 0) {
        commit("SET_ORGANIZE_LIST", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getNotice({ commit }, content) {
      // 获取来访须知
      const { data } = await http.getNotice(content);
      commit("SET_NOTICE", data.data);
    },
    async getMainPhoto({ commit }, content) {
      //获取主图信息
      const { data } = await http.getMainPhoto(content);
      commit("SET_MAIN_PHOTO", data);
    },

    /**
     * 整合获取拜访事由、获取拜访单位、获取访客类型、获取组织列表
     * @param {*} param0
     * @param {*} content
     */
    async getServer({ commit }, content) {
      const { data } = await http.getServer(content);
      commit("SET_SERVER", data.data);
    },
    async logOut({ commit }, content) {
      // 退出员工登录
      const { data } = await http.logOut(content);
      commit("SET_DATA", data);
    },
    async uploadExcel({ commit }, content) {
      //
      const { data } = await http.uploadExcel(content);

      console.log(data);
      commit("SET_DATA_INFO", data);
    },


    // 移动端登录
    async carLogin({ commit }, content) {
      const { data } = await http.carLogin(content);
      if (data.code === 0) {
        commit("SET_CAR_USER", data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // 移动端登录
    async carLoginMobile({ commit }, content) {
      const { data } = await http.carLoginMobile(content);
      if (data.code === 0) {
        commit("SET_CAR_USERMOBILE", data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 获取车辆录入的情况
    async getCarRecord({ commit }, content) {
      const { data } = await http.getCarRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 添加车牌
    async carCreate({ commit }, content) {
      const { data } = await http.carCreate(content);
      commit("SET_DATA", data);
    },
    // 获取登录状态
    async isLogin({ commit }) {
      const { data } = await http.isLogin();
      commit("SET_DATA", data);
    },

    // 获取当前二维码
    async getQR({ commit }, content) {
      const { data } = await http.getQR(content);
      if (data.code === 0) {
        commit("SET_CAR_QR", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // 创建或刷新二维码
    async createQR({ commit }, content) {
      const { data } = await http.createQR(content);


      commit("SET_DATA", data);
    },

    // 通过二维码的方式录入车牌
    async qrCreateCar({ commit }, content) {
      const { data } = await http.qrCreateCar(content);

      commit("SET_DATA_SECRETID", data);
    },

    // 检验二维码是否合法
    async checkQr({ commit }, content) {
      const { data } = await http.checkQr(content);
      commit("SET_DATA", data);
    },

    //
    async getCarDetail({ commit }, content) {
      const { data } = await http.getCarDetail(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
  }
});



// WEBPACK FOOTER //
// ./src/store.js